import { useLoadingAnimation } from '@/components/LoadingAnimation/useLoadingAnimation.hook';
import { DEFAULT_ERROR_MESSAGE } from '@/config/text.const';
import { HttpStatusCode } from '@/services/http/HttpStatusCodes';
import { bulkClUpdateClient } from '@/services/http/clients/bulkClUpdateClient';
import { notificationService } from '@/services/notification/notification.client';

export type UploadUpliftFileFields = {
  file: File | undefined;
};

type FileUploadProps = {
  values: UploadUpliftFileFields;
  successCallback?: Function;
};

export default function useUploadFile() {
  const { toggleLoadingAnimation } = useLoadingAnimation();

  const onFileUpload = async ({ values, successCallback }: FileUploadProps) => {
    toggleLoadingAnimation(true);
    const uploadedFile = new FormData();

    if (values.file) {
      uploadedFile.append('upliftsFile', values.file);
    }

    return bulkClUpdateClient.post('/UploadDocumentFunction', uploadedFile, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
    })
      .then((uploadResult) => {
        if (uploadResult?.status === HttpStatusCode.OK) {
          successCallback?.();
          notificationService.open({
            title: 'Success',
            text: 'File uploaded successfully',
            type: 'success'
          });
        }
      })
      .catch((err) => {
        notificationService.open({
          title: 'Upload file',
          text: err?.message ?? DEFAULT_ERROR_MESSAGE,
          type: 'danger'
        });
      })
      .finally(() => toggleLoadingAnimation(false));
  };

  return {
    onFileUpload
  };
}
